import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { ProposalsScreenComponent } from './ProposalsScreen.types'
import { useProposalsScreen } from './useProposalsScreen'

const ProposalsScreenDesktop = lazy(() => import('./ProposalsScreen.desktop'))

export const ProposalsScreen: ProposalsScreenComponent = ({ navigation, route }) => {
  const props = useProposalsScreen({ navigation, route })

  const Screen = ProposalsScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
